import { Form } from 'antd'
import styled from 'styled-components'

import { Button } from '@/components/shared-components/BUI/Button'

export const FormItem = styled(Form.Item)`
  margin-bottom: 0;

  .ant-form-item-required::before {
    margin-top: 0.3em !important;
    margin-bottom: auto !important;
  }
`

export const CaptureBlockActionButton = styled(Button).attrs({
  variant: 'primary-text',
  size: 'small',
})`
  padding-left: 0.25rem;
  padding-right: 0.25rem;
`
